import { Card, Heading, SimpleGrid, Stat } from "@chakra-ui/react"
import type { QuestionAnalyticsSummary } from "../../../client"

interface SummaryStatsCardProps {
  summary: QuestionAnalyticsSummary
}

export default function SummaryStatsCard({ summary }: SummaryStatsCardProps) {
  return (
    <Card.Root h="full">
      <Card.Body>
        <Heading size="md" mb={4}>
          Summary
        </Heading>
        <SimpleGrid columns={1} gap={4}>
          <Stat.Root>
            <Stat.Label>Overall Correctness</Stat.Label>
            <Stat.ValueText>
              {summary.overall_correct_percentage.toFixed(1)}%
            </Stat.ValueText>
            <Stat.HelpText>of attempts were correct</Stat.HelpText>
          </Stat.Root>

          <Stat.Root>
            <Stat.Label>Average Time</Stat.Label>
            <Stat.ValueText>
              {summary.average_time_seconds.toFixed(0)}s
            </Stat.ValueText>
            <Stat.HelpText>
              Median: {summary.median_time_seconds.toFixed(0)}s
            </Stat.HelpText>
          </Stat.Root>

          <Stat.Root>
            <Stat.Label>Practice Quizzes</Stat.Label>
            <Stat.ValueText>
              {summary.practice_quiz_percentage.toFixed(1)}%
            </Stat.ValueText>
            <Stat.HelpText>of attempts</Stat.HelpText>
          </Stat.Root>
        </SimpleGrid>
      </Card.Body>
    </Card.Root>
  )
}
